import { GET_STATISTIC } from './actions/statistic'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Statistic = RepositoryFactory.get('statistic')

export default {
  namespaced: true,
  state: {
    statistic: [],
  },
  getters: {
    [GET_STATISTIC]: state => state.statistic,
  },
  actions: {
    [GET_STATISTIC]: ({ commit }) => {
      Statistic.getStatistic().then(res => {
        const { data } = res

        commit(GET_STATISTIC, data)
      })
    },
  },
  mutations: {
    [GET_STATISTIC]: (state, data) => {
      state.statistic = data
    },
  },
}
